/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".full-width[_ngcontent-%COMP%]{width:100%}.half-width[_ngcontent-%COMP%]{width:50%}.pad-b-7[_ngcontent-%COMP%]{padding-bottom:7px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/css/master-reports.component.less.shim.ngstyle.js.pre-build-optimizer.js